import { Tabs } from '../../../ui';
import DefaultLayout from '../../components/DefaultLayout';
import { useIntl } from 'react-intl';
import { useAuth } from '../../../hooks/useAuth';
import {
  StyledFarmContractsPage,
  StyledFarmContractsPageContent,
} from './style';
import { Form } from 'antd';
import {
  StyledMobileHeaderWrapper,
  StyledMobilePageTitle,
} from 'admin/components/MobileLayout/style';
import { Contracts } from '../../components/EditFarm/Contracts/Contracts';

export const FarmContracts = () => {
  const intl = useIntl();
  const { user } = useAuth();
  const [form] = Form.useForm();

  const items = [
    {
      key: 'contracts',
      label: intl.formatMessage({ id: 'contracts.active_contracts' }),
      children: <Contracts farmId={user?.farmId ?? ''} />,
    },
  ];

  return (
    <StyledFarmContractsPageContent>
      <StyledMobileHeaderWrapper />
      <DefaultLayout.PageLayout
        breadcrumbs={[
          {
            title: intl.formatMessage({ id: 'navigation.beginning' }),
          },
          {
            title: intl.formatMessage({ id: 'navigation.contracts' }),
          },
        ]}
      >
        <DefaultLayout.PageContent>
          <StyledFarmContractsPage>
            <StyledMobilePageTitle>
              <span>{intl.formatMessage({ id: 'navigation.contracts' })}</span>
            </StyledMobilePageTitle>
            <Form form={form}>
              <Tabs items={items} />
            </Form>
          </StyledFarmContractsPage>
        </DefaultLayout.PageContent>
      </DefaultLayout.PageLayout>
    </StyledFarmContractsPageContent>
  );
};
